// NOTE: Since we are not using state for xmpp_messaging store at all.
//       This is just to have consistency in the way of declaring StateType.

const state = null;

export type StateType = typeof state;
export default state;
